// extracted by mini-css-extract-plugin
export var bubble = "_2e-0";
export var container = "_2e-3";
export var contrastBorder = "_2e-4";
export var greyOut = "_2e-2";
export var initialsWrapper = "_2e-1";
export var large = "_2e-9";
export var medium = "_2e-8";
export var mediumSmall = "_2e-7";
export var mediumSmallMedium = "_2e-c";
export var micro = "_2e-5";
export var small = "_2e-6";
export var tiny = "_2e-b";
export var xTiny = "_2e-a";